import { staffMemberDetailsFragment } from "@saleor/fragments/staff";
import makeQuery from "@saleor/hooks/makeQuery";
import gql from "graphql-tag";

import {
  AccountAssignBrand,
  AccountAssignBrandVariables
} from "./types/AccountAssignBrand";
import {
  AccountAssignMall,
  AccountAssignMallVariables
} from "./types/AccountAssignMall";
import {
  AccountAssignTenant,
  AccountAssignTenantVariables
} from "./types/AccountAssignTenant";
import {
  AccountSettingDetails,
  AccountSettingDetailsVariables
} from "./types/AccountSettingDetails";

export const accountSettingDetails = gql`
  ${staffMemberDetailsFragment}
  query AccountSettingDetails($id: ID!) {
    user(id: $id) {
      ...StaffMemberDetailsFragment
    }
  }
`;

export const useAccountSettingDetails = makeQuery<
  AccountSettingDetails,
  AccountSettingDetailsVariables
>(accountSettingDetails);

export const accountAssignTenant = gql`
  query AccountAssignTenant($id: ID!) {
    tenant(id: $id) {
      id
      storeName
      brand {
        id
        name
        legalName
      }
    }
  }
`;
export const useAccountAssignTenant = makeQuery<
  AccountAssignTenant,
  AccountAssignTenantVariables
>(accountAssignTenant);

export const accountAssignBrand = gql`
  query AccountAssignBrand($id: ID!) {
    brand(id: $id) {
      id
      name
      legalName
    }
  }
`;
export const useAccountAssignBrand = makeQuery<
  AccountAssignBrand,
  AccountAssignBrandVariables
>(accountAssignBrand);

export const accountAssignMall = gql`
  query AccountAssignMall($id: ID!) {
    mall(id: $id) {
      id
      name
    }
  }
`;
export const useAccountAssignMall = makeQuery<
  AccountAssignMall,
  AccountAssignMallVariables
>(accountAssignMall);
